















import { Component, Vue, Prop, State, Watch } from 'nuxt-property-decorator'

@Component
export default class Tag extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Prop({ default: () => null }) tags!: any
  @Prop({ default: false }) visible!: boolean

  paddingBottom: number = 12
  elementObserver: any = null
  observeDom: null | HTMLElement = null

  @Watch('visible', { immediate: true })
  onVisibleChange(val: boolean) {
    if (process.client) {
      if (val) {
        this.calcHeight()
      } else {
        this.observeDom && (this.observeDom.style.maxHeight = 'none')
        this.destroyObserver()
      }
    }
  }

  get valid() {
    return !!this.tags?.length
  }

  genSpm(tag: any, index: number) {
    const { city_id = '', country_id = '', poi_id, track_info = {}, tag_id = '' } = tag
    const ext: any = {
      ...track_info,
      city_id,
      country_id,
      poi_id,
      tag_id
    }

    return `Recommendation_LIST?idx=${index}&len=${this.tags.length}&ext=${encodeURIComponent(JSON.stringify(ext))}`
  }

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get limit() {
    // desktop: 48 * 3  mweb: 48 * 3
    return this.isDesktop ? 96 : 144
  }

  createObserver() {
    if ('IntersectionObserver' in window) {
      this.elementObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 如果元素可见
            if (entry.intersectionRatio > 0) {
              this.$nextTick(() => {
                this.calcHeight()
                this.destroyObserver()
              })
            }
          })
        },
        { threshold: [0.1] }
      )

      this.$el && this.elementObserver.observe(this.$el)
    }
  }

  contentRendered() {
    this.$nextTick(() => {
      this.$emit('rendered')
    })
  }

  calcHeight() {
    this.$nextTick(() => {
      if (this.$el) {
        const { scrollHeight } = this.$el
        this.observeDom = this.$el as HTMLElement

        if (scrollHeight > this.limit) {
          ;(this.$el as HTMLElement).style.maxHeight = this.limit - this.paddingBottom + 'px'
        } else if (scrollHeight === 0) {
          this.createObserver()
        } else {
          (this.$el as HTMLElement).style.maxHeight = scrollHeight - this.paddingBottom + 'px'
        }

        this.contentRendered()
      }
    })
  }

  destroyObserver() {
    this.elementObserver && this.observeDom && this.elementObserver.unobserve(this.observeDom)
  }

  beforeDestroy() {
    this.destroyObserver()
  }
}
